import { Component, inject } from '@angular/core';
import { GeneralEventsService } from './services/general-events.service';
import { ShellV2Module } from '@schenck/rotec-components';

@Component({
  selector: 'rm-app',
  templateUrl: './app.component.html',
  imports: [ShellV2Module],
})
export class AppComponent {
  private readonly generalEventsService = inject(GeneralEventsService);

  public sideBarCollapse(collapsed: boolean) {
    this.generalEventsService.toggleSidebar(collapsed);
  }
}
